import React, { useEffect, useState } from 'react'
import Shape15 from "../../../assets/images/shape-15.png"
import Course1 from "../../../assets/images/courses-1.jpg"
import Course2 from "../../../assets/images/courses-2.jpg"
import Icon1 from "../../../assets/images/icon-7.png"
import Icon2 from "../../../assets/images/icon-6.png"
import Slider from 'react-slick'
import courseImg1 from '../../../assets/images/courses/courses-1.jpg'
import courseImg2 from '../../../assets/images/courses/courses-2.jpg'
import { axiosInstance, config } from '../config'

const CourseSection = () => {

    const [Cources, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getCources();
    }, [])

    function getCources() {
        axiosInstance.get(`get-cources`)
            .then(res => {
                setCourses(res.data.cources.filter(co => co.status == '0'))
            })
            .catch((err) => console.log(err))
    }

    // const settings = {
    //     dots: false,
    //     fade: false,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     waitForAnimate: false,
    //     arrows: false,
    //     autoplay: true,
    //     responsive: [
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 3,
    //                 infinite: true,
    //                 dots: true
    //             }
    //         },
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 2,
    //                 initialSlide: 2
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1
    //             }
    //         }
    //     ]
    // };

    // const highlights = [
    //     "Speed Learning Institute",
    //     "One Stop Driving School",
    //     "Advanced Driving Techniques",
    //     "Beyond 5 Star Driving School",
    //     "Excellent Drivers Academy",
    //     "Speed Learning Institute",
    //     "One Stop Driving School",
    //     "Advanced Driving Techniques",
    //     "Beyond 5 Star Driving School",
    //     "Excellent Drivers Academy",
    // ]

    return (
        <div>
            <section className="courses-section">
                <div className="pattern-layer" style={{ backgroundImage: `url(${Shape15})` }}></div>
                <div className="line-box">
                    <div className="line line-1"></div>
                    <div className="line line-2"></div>
                    <div className="line line-3"></div>
                </div>
                <div className="auto-container">
                    <div className="sec-title">
                        <h2>Course to drive with confidence</h2>
                    </div>
                    <div className="row align-items-center clearfix">
                        {
                            Cources.slice(0, 2).map((course, i) => {
                                return (
                                    (i % 2 == 0) ? (
                                        <div className="left-column">
                                            <div className="inner-box d-block d-xl-flex align-items-end gap-5">
                                                <div className="image-box col-xl-6">
                                                    <div className="text">
                                                        <h6 className='text-white'>From</h6>
                                                        <h2 className='text-white'>{course.price}<span className='text-white'>£</span></h2>
                                                        {/* <h5 className='text-white'>Per Person</h5> */}
                                                    </div>
                                                    <figure className="image">
                                                        <img src={course.imageUrl} alt="" /></figure>
                                                </div>
                                                <div className="content-box col-xl-6">
                                                    <h6>{course.cartype}</h6>
                                                    <h2>{course.title}</h2>
                                                    <p>{course.description.slice(0, 80)}...</p>
                                                    <div className="inner">
                                                        <div className="row clearfix">
                                                            <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                                                <div className="single-item">
                                                                    <div className="icon-box"><img src={Icon1} alt="" /></div>
                                                                    <h6><a href="#">Theory Session</a></h6>
                                                                    <span>{course.theory} Hours</span>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                                                <div className="single-item">
                                                                    <div className="icon-box"><img src={Icon2} alt="" /></div>
                                                                    <h6><a href="#">Practical Session</a></h6>
                                                                    <span>{course.practical} Hours</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button className='mb-3 w-100'><a href={`${config.appUrl}book-a-lesson`} className='theme-btn btn-one text-white w-100'>Book Now</a></button>
                                                    {/* <div className="lower-content">
                                                        <h5><i className="bi bi-info-circle-fill"></i>Driving route will be charged separately.</h5>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="right-column">
                                            <div className="inner-box d-block d-xl-flex align-items-end gap-5">
                                                <div className="content-box col-xl-6 pe-2">
                                                    <h6>{course.cartype}</h6>
                                                    <h2>{course.title}</h2>
                                                    <p>
                                                        {course.description.slice(0, 80)}...
                                                    </p>
                                                    <div className="inner">
                                                        <div className="row clearfix">
                                                            <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                                                <div className="single-item">
                                                                    <div className="icon-box"><img src={Icon1} alt="" /></div>
                                                                    <h6><a href="#">Theory Session</a></h6>
                                                                    <span>{course.theory} Hours </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                                                                <div className="single-item">
                                                                    <div className="icon-box"><img src={Icon2} alt="" /></div>
                                                                    <h6><a href="#">Practical Session</a></h6>
                                                                    <span>{course.practical} Hours</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button className='mb-3 w-100'><a href={`${config.appUrl}book-a-lesson`} className='theme-btn btn-one text-white w-100'>Book Now</a></button>
                                                    {/* <div className="lower-content">
                                                        <h5><i className="bi bi-info-circle-fill"></i>Driving route will be charged separately.</h5>
                                                    </div> */}
                                                </div>
                                                <div className="image-box col-xl-6">
                                                    <div className="text">
                                                        <h6 className='text-white'>From</h6>
                                                        <h2 className='text-white'>{course.price}<span className='text-white'>£</span></h2>
                                                        {/* <h5 className='text-white'>Per Person</h5> */}
                                                    </div>
                                                    <figure className="image"><img src={course.imageUrl} alt="" /></figure>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                            })
                        }
                    </div>
                </div>
            </section>

            {/* <section className="highlights-section">
                <div className="outer-container">
                    <Slider {...settings} >
                        {highlights?.map((high, i) => {
                            return (
                                <div className="single-item pe-4" key={i}>
                                    <h4><i className="bi bi-arrow-right-square-fill"></i>{high}</h4>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </section> */}
        </div>
    )
}

export default CourseSection
